import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchSurveyTypes(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/survey/admin/surveytypes')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addSurveyType(ctx, surveyTypeData) {
      return new Promise((resolve, reject) => {
        axios
          .post('/survey/admin/surveytype', surveyTypeData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateSurveyType(ctx, { id, surveyTypeData }) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/survey/admin/surveytype/${id}`, surveyTypeData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteSurveyType(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/survey/admin/surveytype/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchSurveyTypeTags(ctx, { surveyTypeId }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/survey/admin/getallquestiontags?t=${surveyTypeId}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addSurveyTypeTag(ctx, tagData) {
      return new Promise((resolve, reject) => {
        axios
          .post('/survey/admin/questiontag', tagData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateSurveyTypeTag(ctx, { id, tagData }) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/survey/admin/questiontag/${id}`, tagData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteSurveyTypeTag(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/survey/admin/questiontag/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
